import { render, staticRenderFns } from "./ConstructionTaskEditPage.vue?vue&type=template&id=5241eb0d&"
import script from "./ConstructionTaskEditPage.vue?vue&type=script&lang=ts&"
export * from "./ConstructionTaskEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports